export const VQ_LETTERBOX_URL = '/vq/addresses/lookup';
